export default "__VITE_ASSET__CqEGHLf6__"